import { Avatar as MAvatar } from '@mantine/core';
import classes from './avatar.module.scss';

export const Avatar = MAvatar.extend({
  classNames: classes,
});
